import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronDown, Menu } from 'lucide-react'
import { MegaMenu } from './MegaMenu'
import { MobileMenu } from './MobileMenu'
import { cn } from '@/lib/utils'

export function Header() {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()

  const isActive = (path: string) => location.pathname === path

  return (
    <header className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-gray-200">
      <div className="container">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.png" alt="AI Detector Arena" className="w-8 h-8" />
            <span className="font-semibold text-gray-800">
              AI Detector Arena
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {/* Tools Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsMegaMenuOpen(!isMegaMenuOpen)}
                onMouseEnter={() => setIsMegaMenuOpen(true)}
                className={cn(
                  'flex items-center gap-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors',
                  isMegaMenuOpen
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                )}
              >
                Tools
                <ChevronDown className={cn(
                  'w-4 h-4 transition-transform',
                  isMegaMenuOpen && 'rotate-180'
                )} />
              </button>
            </div>

            <Link
              to="/arena"
              className={cn(
                'px-4 py-2 rounded-lg text-sm font-medium transition-colors',
                isActive('/arena')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
              )}
            >
              Arena
            </Link>

            <Link
              to="/"
              className={cn(
                'px-4 py-2 rounded-lg text-sm font-medium transition-colors',
                isActive('/')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
              )}
            >
              Rankings
            </Link>

            <Link
              to="/check"
              className={cn(
                'px-4 py-2 rounded-lg text-sm font-medium transition-colors',
                isActive('/check')
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
              )}
            >
              Detector
            </Link>

          </nav>


          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Menu className="w-6 h-6 text-gray-600" />
          </button>
        </div>
      </div>

      {/* Mega Menu */}
      <div onMouseLeave={() => setIsMegaMenuOpen(false)}>
        <MegaMenu isOpen={isMegaMenuOpen} onClose={() => setIsMegaMenuOpen(false)} />
      </div>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </header>
  )
}
